import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BetHistoryList from './BetHistoryList';
import getErrorText from './getErrorText';
import { formatDate } from '../../common/utils/formatDateTime';
import { betPropTypes } from '../BetPropTypes';
import {
    BET_HISTORY_MAX_PAGES_COUNT,
    BET_HISTORY_REDIRECT_CONFIG,
} from './betHistory.constants';

import Svg from '../../common/svgIcon';
import './styles.scss';


export class BetHistoryIntegrated extends Component {

    componentWillMount() {
        this.requestInitialBetHistory(this.props.isSettled);
    }

    componentWillUnmount() {
        this.props.clearBetHistory();
    }

    handleToggleIsSettled = () => {
        this.props.toggleIsSettled();
        this.requestInitialBetHistory(!this.props.isSettled);
    }

    requestInitialBetHistory = (isSettled) => {
        const { getBetHistory, apiName } = this.props;
        getBetHistory(apiName, isSettled);
    }

    incrementPage = () => {
        const {
            currentPage,
            betHistoryPageChange,
        } = this.props;
        const page = currentPage + 1;
        betHistoryPageChange(page);
    }

    decrementPage = () => {
        this.props.betHistoryPageChange(this.props.currentPage - 1);
    }

    renderPageBody = () => {
        const {
            apiName,
            bookmakerName,
            betHistory,
            isSettled,
            isLoading,
            currencySign,
            currentPage,
        } = this.props;
        const redirectConfig = BET_HISTORY_REDIRECT_CONFIG[apiName] || {};

        const days = betHistory.reduce((day, bet) => {
            const date = bet.timeBetPlaced.split('T')[0];

            if (!day[date]) {
                day[date] = [];
            }

            day[date].push(bet);
            
            return day;
        }, {});
        
        const groupedBets = Object.keys(days).map((date) => {
            const formatedDate = formatDate(date)
            return {
                formatedDate,
                bets: days[date]
            };
        });

        return currentPage === BET_HISTORY_MAX_PAGES_COUNT + 1 ? (
            <div className="bs-betHistory__message">
                <span>
                    {redirectConfig.text} <a
                        href={`https://${redirectConfig.link}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {redirectConfig.link}
                    </a>
                </span>
            </div>
            ) : (
                groupedBets.map((day, index) => (
                    <Fragment key={`day-${index}`}>
                        <div className="MyBetsDateHeader" data-test-selector="Text__BetHistoryDate">
                            {day.formatedDate}
                        </div>

                        <BetHistoryList
                            bookmakerName={bookmakerName}
                            isSettled={isSettled}
                            isLoading={isLoading}
                            currencySign={currencySign}
                            bets={day.bets}
                        />
                    </Fragment>
                ))
            )
    }

    render() {
        const {
            betHistory,
            isSettled,
            isLoading,
            betHistoryErrors,
        } = this.props;
        const betHistoryErrorText = betHistoryErrors && getErrorText(betHistoryErrors);
        const isInitialBetHistoryLoading = isLoading && !betHistory.length;

        return (
            <div className="bs-myBetsContainer">
                <section className='root'>
                    <nav className="root__betPageHeader">

                        <div className="root__betPageHeaderContent root__rnCanvas">
                            
                            <div className="root__betPageHeaderContentSecondaryHeaderRow HeaderTitleContainer">
                                <div className='root__pageHeaderMainTitle'>
                                    <Svg iconName='bookmakerLogo' size='Large' />
                                    <h1>my bets</h1>
                                </div>

                                <a
                                    href='/my-bookmakers'
                                    className='root__betPageHeaderText back-button ShowOnMobile'
                                    data-test-selector="Link__MyBookmakersPage"
                                >
                                        <Svg iconName='chevronLeft' size='regular' />
                                        Manage bookmakers
                                </a>
                            </div>

                            <div className="root__betPageHeaderContentSecondaryHeaderRow">
                                <div className="root__betPageHeaderContentSecondaryHeaderRowLeft HideOnMobile">
                                    <a
                                        href='/my-bookmakers'
                                        className='root__betPageHeaderText back-button'
                                        data-test-selector="Link__MyBookmakersPage"
                                        >
                                            <Svg iconName='chevronLeft' size='regular' />
                                            Manage bookmakers
                                    </a>
                                </div>

                                <div className="root__betPageHeaderContentSecondaryHeaderRowRight">
                                    <span className="root__bookmakersDropdownContentRight">
                                        <button
                                            onClick={this.handleToggleIsSettled}
                                            className="bs-btn bs-btn_major bs-betHistory__toggleButton"
                                            data-test-selector="Button__ToggleSettledBets"
                                        >
                                            <div className={
                                                classNames(
                                                    'toggleOption',
                                                    { 'settled': !isSettled },
                                                )}
                                            >
                                                OPEN
                                            </div>
                                            <div className={
                                                classNames(
                                                    'toggleOption',
                                                    { 'settled': isSettled },
                                                )}
                                            >
                                                SETTLED
                                            </div>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </nav>

                    {
                            betHistoryErrors ? (
                                <div className="bs-betHistory__error" data-test-selector="Text__BetHistoryError">
                                    {betHistoryErrorText}
                                </div>
                            ) : (
                                <div className={
                                    classNames(
                                        'bs-betHistory__content',
                                        { 'bs-betHistory__content_spinner': isInitialBetHistoryLoading },
                                    )}
                            >
                                <section className='root__pageContent root__rnCanvas'>
                                    <div className='MyBets' data-test-selector="Container__BetHistory">

                                        {this.renderPageBody()}
                                    </div>
                                </section>
                            </div>
                        )
                    }

                </section>
            </div>
        );
    }
}

BetHistoryIntegrated.defaultProps = {
    isSettled: false,
    isLoading: false,
    betHistoryNext: null,
    betHistoryErrors: null,
    hasNextPage: false,
};

BetHistoryIntegrated.propTypes = {
    analyticsName: PropTypes.string,
    isSettled: PropTypes.bool,
    isLoading: PropTypes.bool,
    getBetHistory: PropTypes.func.isRequired,
    clearBetHistory: PropTypes.func.isRequired,
    betHistoryPageChange: PropTypes.func.isRequired,
    toggleIsSettled: PropTypes.func.isRequired,
    apiName: PropTypes.string.isRequired,
    betHistory: PropTypes.arrayOf(betPropTypes).isRequired,
    currencySign: PropTypes.string.isRequired,
    pageLength: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    betHistoryErrors: PropTypes.objectOf(PropTypes.shape({
        message: PropTypes.string,
    })),
    hasNextPage: PropTypes.bool,
    bookmakerName: PropTypes.string,
};

export default BetHistoryIntegrated



// WEBPACK FOOTER //
// /src/js/BetHistory/components/BetHistoryIntegrated.jsx